import { apiClient } from '../client';

// Types are camelCase - API client already transforms snake_case responses
export interface User {
  id: string;
  email: string;
  name: string | null;
  isAdmin: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface BarMembership {
  barId: string;
  barName: string;
  role: 'owner' | 'manager';
}

export interface MeResponse {
  success: boolean;
  user: User;
  managedBars: BarMembership[];
  authMethod: string;
}

export const authApi = {
  me: async (): Promise<MeResponse> => {
    const { data } = await apiClient.get<MeResponse>('/auth/me');
    return data;
  },

  deleteAccount: async (): Promise<{ success: boolean }> => {
    const { data } = await apiClient.delete<{ success: boolean }>('/auth/me');
    return data;
  },
};
